export const DOG_ICON = 'pets';
export const CERTIFY_ICON = 'emoji_events';
export const RECORD_ICON = 'videocam';
